import { Component, OnInit, Input, OnDestroy } from '@angular/core';

import {Plugins} from '@capacitor/core';
const { BarcodeScanner } = Plugins;
import { AlertController, ModalController } from '@ionic/angular';
import { FormServiceService } from 'src/app/services/publications/form-service.service';
import { RequestService } from 'src/app/services/request/request.service';
import { Utils } from 'src/app/Models/Classes/utils';
import { AccessUserData } from 'src/app/Models/Classes/User/access-user-data';
import Swal2 from 'sweetalert2';
import { Capacitor } from '@capacitor/core';
import { Html5QrcodeScanner, Html5Qrcode } from "html5-qrcode";
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
@Component({
  selector: 'app-qr-code-generator',
  templateUrl: './qr-code-generator.component.html',
  styleUrls: ['./qr-code-generator.component.scss'],
})
export class QrCodeGeneratorComponent implements OnInit, OnDestroy {
  @Input() scanMode: 'ticket' | 'hubble' | 'apple-tv' | 'profile-transfer' = 'ticket';
  html5QrCodeScanner: Html5QrcodeScanner | null = null;
  result=null;
  rawResult: string | null = null;
  scanActive= false;
  nativePreviewReady = false;
  scanHandled = false;
  public walletHubble:boolean=true;
  //@Input() qrData: string = '';
  web:boolean=false;
  private nativePreviewTimer: ReturnType<typeof setTimeout> | null = null;

  constructor(
    public alertController: AlertController,
    private formservice:FormServiceService,
    private request:RequestService,
    private modalcoontroller: ModalController,
    private utils: Utils,
    private router: Router,
    private activatedRoute: ActivatedRoute,
  ) { }

  ngOnInit() {
   const routeScanMode = this.activatedRoute.snapshot.queryParamMap.get('scanMode');
   if (routeScanMode === 'apple-tv') {
    this.scanMode = 'apple-tv';
   }
  
   // 
   const hasNativeBarcodeScanner =
     !!BarcodeScanner &&
     typeof BarcodeScanner.prepare === 'function' &&
     typeof BarcodeScanner.startScan === 'function' &&
     typeof BarcodeScanner.checkPermission === 'function';

   if (Capacitor.getPlatform() !== 'ios') {
    this.web=true;
    this.initWebScanner();

   }else{
    if (hasNativeBarcodeScanner) {
      BarcodeScanner.prepare();
      document.body.classList.remove('dark');
      this.formservice.mostrar = false;
      this.startScanner();
      return;
    }

    this.web = true;
    document.body.classList.remove('dark');
    this.formservice.mostrar = false;
    setTimeout(() => this.startWebScanner(), 0);
   }
  
  

  }
  initWebScanner() {
    Swal2.fire({
      title: 'Web Scanner',
      text: 'Using web QR code scanner.',
      icon: 'info',
      confirmButtonText: 'Start Scanning',
      background: '#010f4e',
      position: 'top-end',
      showCancelButton:true,
      timerProgressBar: true,
      toast: true,
      cancelButtonText:'cancel'
  }).then((result) => {
      if (result.isConfirmed) {
      document.body.classList.remove('dark');
            //document.body.classList.toggle('dark');
      this.formservice.mostrar = false;
      this.startWebScanner();
      }
    });
  }
  async startWebScanner() {
    this.scanHandled = false;
    if (!Html5Qrcode.getCameras()) {
      Swal2.fire({
        title: 'No Camera',
        text: 'No camera found or camera permissions denied.',
        icon: 'error',
        confirmButtonText: 'Ok',
        background: '#010f4e',
          position: 'top-end',
          timerProgressBar: true,
          toast: true,
      });
      return;
    }

    this.html5QrCodeScanner = new Html5QrcodeScanner(
      "reader",
      {
        fps: 10,
        qrbox: 250,
        // Prefer the rear camera without rejecting devices that only expose
        // one browser camera stream.
        videoConstraints: { facingMode: { ideal: 'environment' } },
      },
      false
    );

    this.html5QrCodeScanner.render(
      this.onScanSuccess.bind(this),
      this.onScanFailure.bind(this)
    );
  }

  stopWebScanner() {
    if (this.html5QrCodeScanner) {
      this.html5QrCodeScanner.clear();
    }
  }
  onScanSuccess(decodedText: string, decodedResult: any) {
    if (this.scanHandled) {
      return;
    }

    this.scanHandled = true;
    this.rawResult = decodedText;
    this.result = this.removeHttps(decodedText);
    console.log(`Scan result: ${decodedText}`, decodedResult);
    if (this.html5QrCodeScanner) {
      this.html5QrCodeScanner.clear();
    }
    this.serverScan(decodedText);
  }

  onScanFailure(error: any) {
    const message = typeof error === 'string' ? error : error?.toString?.() || '';

    if (message.includes('NotFoundException') || message.includes('No MultiFormat Readers were able to detect the code')) {
      return;
    }

    console.warn(`QR Code Scan Error: ${message || error}`);
  }

  ngOnDestroy(): void {
    this.formservice.mostrar = true;
   
    this.formservice.scanActive=false;
    this.scanHandled = false;
    document.body.classList.add('dark');
      Swal2.close();

    if(!this.web){
      BarcodeScanner.stopScan();
    }else{
      this.stopWebScanner();
    }
   
  }




  async startScanner() {
    this.scanHandled = false;
    if (!BarcodeScanner || typeof BarcodeScanner.checkPermission !== 'function') {
      this.web = true;
      this.startWebScanner();
      return;
    }

    const allowed = await this.checkPermission();
    if (allowed) {
      BarcodeScanner.hideBackground();
      this.scanActive = true;
      this.nativePreviewReady = false;
      const scanPromise = BarcodeScanner.startScan({ cameraDirection: 'back' });

      // The legacy native scanner has no first-frame event. Keep the WebView
      // completely black during startup, then reveal only the scan window.
      if (this.nativePreviewTimer) clearTimeout(this.nativePreviewTimer);
      this.nativePreviewTimer = setTimeout(() => {
        if (this.scanActive) this.nativePreviewReady = true;
      }, 450);

      const result = await scanPromise;
      if (result.hasContent) {
        this.rawResult = result.content;
        this.result = this.removeHttps(result.content); // Remove "https://"
        //this.result = result.content;
        console.log( this.result);
        this.scanActive = false;
        this.stopScanner();
        this.serverScan(result.content);
      }
    }
  }
  

  async checkPermission(){
    return new Promise (async (resolve, reject) => {
      if (!BarcodeScanner || typeof BarcodeScanner.checkPermission !== 'function') {
        resolve(false);
        return;
      }

      const status = await BarcodeScanner.checkPermission({force:true});
      if (status.granted){
      resolve(true);
      }else if (status.denied){
        const alert = await this.alertController.create({
          header: 'No hay permiso',
          message: 'Porfavor autoriza el acceso a la camara en ajustes',
          buttons: [{
            text: 'No',
            role: 'Cancel'
          },
          {
            text: 'Open settings',
            handler: () => {
              BarcodeScanner.openAppSettings();
              resolve(false);
            }
          }

          ]
        });
        await alert.present();

      }else{
        resolve(false);
      }
    });

    }

    stopScanner(){
      if (this.nativePreviewTimer) {
        clearTimeout(this.nativePreviewTimer);
        this.nativePreviewTimer = null;
      }
      this.nativePreviewReady = false;
      BarcodeScanner.stopScan();
      this.scanActive=false;
    }

  serverScan(payload?: string | null) {
    if (this.scanMode === 'profile-transfer') {
      this.modalcoontroller.dismiss({ payload: payload || this.rawResult || this.result });
      return;
    }

    if (this.scanMode === 'apple-tv' || this.isAppleTvPairingPayload(payload || this.rawResult || this.result)) {
      this.approveAppleTvPairing(payload || this.rawResult || this.result);
      return;
    }

      if (this.walletHubble===false){
        this.request.createRequestPost('scanReservations', { id: this.result })
        .then((final_data) => {
         
            Swal2.fire({
              title: 'Ticket Escaneado',
              text: 'El ticket ha sido escaneado exitosamente.',
              icon: 'success',
              confirmButtonText: 'Accept',
              background: '#010f4e',
              position: 'top-end',
              timerProgressBar: true,
              toast: true,
            });
       
        })
        .catch((error) => {
          console.error('An error occurred:', error);
          Swal2.fire({
            title: 'Error',
            text: 'An unexpected error occurred. If the problem persists, contact Laniakea support. Es probable que el ticket ya ha sido escaneado previamente',
            icon: 'error',
            confirmButtonText: 'Understood',
            background: '#010f4e',
            position: 'top-end',
            timerProgressBar: true,
            toast: true,
          });
        });
      }else{
        this.request.createRequestPost('HubbleToHubbleTransfer', { id: this.result })
        .then((final_data) => {
         
            Swal2.fire({
              title: 'Transferencia exitosa',
              text: 'La transferencia ha sido enviada exitosamente.',
              icon: 'success',
              confirmButtonText: 'Accept',
              background: '#010f4e',
              position: 'top-end',
              timerProgressBar: true,
              toast: true,
            });
            this.modalcoontroller.dismiss();
       
        })
        .catch((error) => {
          console.error('An error occurred:', error);
          Swal2.fire({
            title: 'Error',
            text: 'An unexpected error occurred. If the problem persists, contact Laniakea support. Es probable que el ticket ya ha sido escaneado previamente',
            icon: 'error',
            confirmButtonText: 'Understood',
            background: '#010f4e',
            position: 'top-end',
            timerProgressBar: true,
            toast: true,
          });
        });
      }
     
    }

  private async approveAppleTvPairing(payload: string | null = this.rawResult || this.result) {
    const pairingCode = this.extractAppleTvPairingCode(payload);

    if (!pairingCode) {
      Swal2.fire({
        title: 'Apple TV',
        text: 'El QR no contiene un codigo valido de Apple TV.',
        icon: 'error',
        confirmButtonText: 'Entendido',
        background: '#010f4e',
        position: 'top-end',
        timerProgressBar: true,
        toast: true,
      });
      return;
    }

    try {
      const accessData = await this.utils.getAccessData() as AccessUserData;
      const authorization = accessData?.getAuthorization();

      if (!authorization?.trim()) {
        this.modalcoontroller.dismiss();
        this.router.navigate(['/login', 'null'], {
          queryParams: { redirect: '/apple-tv/sync' },
        });
        return;
      }

      await this.request.createRequestPost(
        'apple-tv/pairing-sessions',
        {},
        { id: pairingCode },
        'approve',
      );

      Swal2.fire({
        title: 'Apple TV sincronizado',
        text: 'El token se ha guardado correctamente.',
        icon: 'success',
        confirmButtonText: 'Accept',
        background: '#010f4e',
        position: 'top-end',
        timerProgressBar: true,
        toast: true,
      });
      this.modalcoontroller.dismiss();
    } catch (error) {
      const status = (error as any)?.status;
      const body = (error as any)?.body || (error as any)?.error || (error as any)?.message || '';
      console.error('Apple TV pairing failed', { status, body, error });
      this.scanHandled = false;

      let title = 'Apple TV';
      let text = 'No se pudo sincronizar el Apple TV.';

      if (status === 401) {
        text = 'No tienes una sesion valida para aprobar el Apple TV.';
      } else if (status === 409) {
        text = 'Este codigo ya fue aprobado.';
      } else if (status === 410) {
        text = 'Este codigo de Apple TV expiro.';
      } else if (typeof body === 'string' && body.trim()) {
        text = body;
      }

      Swal2.fire({
        title,
        text,
        icon: 'error',
        confirmButtonText: 'Understood',
        background: '#010f4e',
        position: 'top-end',
        timerProgressBar: true,
        toast: true,
      });
    }
  }

  private extractAppleTvPairingCode(payload: string | null): string | null {
    const trimmed = (payload || '').trim();

    if (!trimmed) {
      return null;
    }

    try {
      const url = trimmed.startsWith('http://') || trimmed.startsWith('https://')
        ? new URL(trimmed)
        : new URL(`https://${trimmed}`);

      return url.searchParams.get('apple_tv_pairing_code')
        || url.searchParams.get('apple_tv_code')
        || null;
    } catch (error) {
      return trimmed;
    }
  }

  private isAppleTvPairingPayload(payload: string | null): boolean {
    const trimmed = (payload || '').trim();

    if (!trimmed) {
      return false;
    }

    try {
      const url = trimmed.startsWith('http://') || trimmed.startsWith('https://')
        ? new URL(trimmed)
        : new URL(`https://${trimmed}`);

      return !!(
        url.searchParams.get('apple_tv_pairing_code') ||
        url.searchParams.get('apple_tv_code')
      );
    } catch (error) {
      return /apple_tv_pairing_code|apple_tv_code/i.test(trimmed);
    }
  }
    
    removeHttps(content: string): string {
      return content.replace(/^https:\/\//i, ''); // Replace "https://" with an empty string
    }   
    dismiss(){
      this.modalcoontroller.dismiss();
    }
  }

  
